import Model from './BaseModel';
import MultiExpressGroupParentMarket from '@/Models/MultiExpressGroupParentMarket';

export default class MultiExpressGroup extends Model {
	resourceName() {
		return 'multi_express_groups';
	}

	fields() {
		return ['sport_id', 'competition_id', 'order'];
	}

	relationships() {
		return {
			parent_markets: new MultiExpressGroupParentMarket()
		};
	}

	saveMultiExpressGroup(data) {
		return this.makePersistRequest({
			url: this.resourceUrl(),
			method: 'POST',
			data
		});
	}
}
